export default __webpack_public_path__ + "922df070a64b0419918c79ed437c9e6e.png";